import { render, staticRenderFns } from "./BikyConfigPersonality.vue?vue&type=template&id=260fbb08&scoped=true&"
import script from "./BikyConfigPersonality.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigPersonality.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigPersonality.vue?vue&type=style&index=0&id=260fbb08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260fbb08",
  null
  
)

export default component.exports